<template>
  <div class="mx-auto max-w-6xl px-4 lg:px-0">
    <div class="min-h-36 md:min-h-[249px]">
      <transition-group name="fade-up" appear>
        <h1
          v-if="show"
          class="text-color-primary py-8 text-center text-3xl leading-none font-bold md:py-20 md:text-5xl"
        >
          Pricing
        </h1>
        <PricingFilter
          v-if="show"
          v-model="interval"
          class="mx-auto"
          :disabled="fetching"
        />
      </transition-group>
    </div>
    <transition name="fade-up" appear>
      <PricingList
        v-if="show"
        class="mt-6"
        :pricing="planOptions"
        :loading="fetching"
        @selected="onPlanSelected"
      ></PricingList>
    </transition>
    <div
      class="mx-auto mt-16 min-h-36 max-w-6xl px-4 pb-16 text-center md:mt-40"
    >
      <template v-if="show">
        <transition-group name="fade-up" appear>
          <h2 class="-mt-1 mb-[34px] text-xl font-bold md:text-2xl lg:text-3xl">
            No more tedious document management!
          </h2>
          <GetStartedBtn />
        </transition-group>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { watchDebounced } from '@vueuse/core';
import GetStartedBtn from '~/components/GetStartedBtn.vue';
import PricingFilter from '~/components/pricing/PricingFilter.vue';
import PricingList from '~/components/pricing/PricingList.vue';
import { usePricing } from '~/composables/pricing/usePricing';
import type { MappedPrice } from '~/types/pricing/Price';
import { PriceProductKey } from '~/utils/enums/Price';

definePageMeta({ layout: 'landing', auth: false });

const router = useRouter();

const onPlanSelected = (price: MappedPrice): void => {
  if (price.type === PriceProductKey.ENTERPRISE) {
    router.push('/auth/enterprise-inquiry');
  }
};

useHead({
  title: 'Pricing',
});

const { fetchPricing, planOptions, fetching, interval } = usePricing();
fetching.value = true;
const show = ref(false);

watchDebounced(interval, fetchPricing, {
  debounce: 250,
  flush: 'post',
  immediate: true,
});

onMounted(() => {
  requestAnimationFrame(() => {
    show.value = true;
  });
});
</script>

<style scoped>
.fade-up-enter-active {
  transition: all 0.6s ease;
}
.fade-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}
</style>
